import Carousel from "bootstrap/js/dist/carousel";

export default function CarouselAutoSlide(carouselId) {
  const carouselEl =  document.querySelector(carouselId);

  if(carouselEl) {
    // Check if data-bs-interval is present
    if (carouselEl.dataset.bsInterval) return;

    const carousel = new Carousel(carouselEl, {
      interval: 5000
    });

    let carouselOnResize = () => {
      if (window.innerWidth >= 992) {
        carousel.pause();
      } else {
        carousel.cycle();
      }
    }

    carouselOnResize();

    window.addEventListener("resize", () => {
      carouselOnResize();
    });
  }
}
